import React from "react";
import { config } from "../../config/config";
import { getSdk } from "../../services/sdkService";
import { EpisodesSelector, Detail, withFocusable, Loading } from "../../services/visualLibraryService";
import { getSupportedVideoTechnology } from "../../services/assetTypesService";
import { getSeasonsAndEpisodesList } from "../../utils/mediaDataRetrieval";
import { DetailPageStyled, ArrowScrollStyled, DetailContainerStyled, DetailWrapperStyled } from "./styles/Styled";
import { withAppState, getAppState } from "../../state";
import { startApp } from "../../index";
import { resolution } from "../../config/ui/resolutionConfig";
import { showAndReportUserRelatedError } from "../../errors/utils";
import {
  getGlobalButtonInfo,
  getGlobalButtonFocusPath,
  getConfigForModalWithCloseButton
} from "../../errors/globalButtons";
import sorter from "../../utils/sortObjectsArray";
import { getSpSportsPackageDisplayName, isSpSportsAddonContent } from "../../services/sportPackageService";
import {
  showChannelSubscriptionErrorPopup,
  showChannelSubscriptionErrorPopupNew,
  isUserSubscribedToChannel,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom
} from "../../utils/subscriptionUtils";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  showResolutionModal,
  showNotLoggedModal,
  showInvalidStatusModal,
  showRetryOrBackModal,
  showForceLogoutError
} from "../../services/modalsService";
import { formatDetailData, getEpisodeLabel } from "../../services/copyService";
import { trackPage, trackEvent, sendUserEvent } from "../../services/analyticsService";
import { getTrailerVideoData, getVideoDataForPlayer, getMediaContentData } from "../../services/mediaService";
import { getUserMediaLists, myListHandler, checkMediaListsData } from "../../services/mediaListService";
import {
  redirectTo,
  trackAndRedirectHandler,
  getNavigationReferences,
  isComingFromDetailPageScope
} from "../../services/navigationService";
import {
  isSuitableFor4KPlayback,
  getTrailer,
  getSeasonsList,
  isSeriesDetailPage,
  getSeasonEpisodeFromMediaGuid,
  findFirstEpisodeBySeason,
  has4KProgramId,
  getEpisodeSelectorData
} from "../../services/titleDataService";
import getRemoteKey from "../../services/remoteService";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { routes } from "../../routes";
import { isFVODFreeToAir, getFVODTitlesFormattedForFullCatalog } from "../../utils/fvodUtils"
import { defaultFocusPath } from "../../components/Header";

const HAS_4K = "4kProgramId";
const MEDIAGUID = "mediaGuid";
const PAGE = "detail";
const PAGE_EPISODE = "episodeSelector";
const PLAY_FROM_LABEL = "details_screen";
const BUTTONS_LIST_NONMOVIES = ["buttonPlay", "buttonTrailer", "buttonWatchlist", "buttonRestart"];
const EPISODEFOCUS = "episodesCarousel";
const SEASONFOCUS = "seasonsCarousel";
const ArrowScrollFocus = withFocusable(ArrowScrollStyled);
let sdk = null;
let SendAnalyticsCallEpisodeOnce = true;
let fromWhere = null;

class DetailPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isExiting = false;
    // FIXME this state is too cluttered (too many elements are added to it when not needed). Not only here, across all the component
    this.state = {
      isLoading: false,
      titleData: null,
      backgroundCover: undefined,
      video: undefined,
      trailer: undefined,
      hasEpisodes: false,
      episodeSelectorLoaded: false,
      isSavedInMyWatchlist: false,
      has4K: false,
      isLoaded: false,
      hasAllDataLoaded: false,
      firstEpisodeAvailable: undefined,
      isPlaying: false,
      slidePage: 0,
      isOnLG: false
    };
    this.wheelState = "idle";
    this.fetchData = this.fetchData.bind(this);
    this.playHandler = this.playHandler.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.play = this.play.bind(this);
    this.getVideoData = this.getVideoData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBack = this.onBack.bind(this);
    this.isRestarting = false;
    this.clearRefreshTimeout = null;
    this.props.stateActions.applyKidsTheme();
    this.isSeries = isSeriesDetailPage.call(this);
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  async componentWillReceiveProps(newProps) {
    if (newProps.location.pathname !== this.props.location.pathname) {
      if (
        (this.props.location && this.props.location.state && !!this.props.location.state.deepLinkReferrer) ||
        (newProps.location && newProps.location.state && !!newProps.location.state.deepLinkReferrer)
      ) {
        this.setState({ backgroundCover: null, hasEpisodes: false, hasAllDataLoaded: false });
        this.props.onRef(this);
      }
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
      this.setState({ titleData: null });
      this.setState({ titleData: await this.fetchData() });
    }
  }

  async componentDidUpdate() {
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  componentWillUnmount() {
    this.isExiting = true;
    this.mounted = false;
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();
    document.removeEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = e => {
    const pressedKey = getRemoteKey(e.keyCode);
    this.wheelState = "idle";
    if (pressedKey === "MEDIA_PLAY") {
      this.playHandler(false);
    } else if (pressedKey === "ARROW_DOWN") {
      if (
        this.state.hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        BUTTONS_LIST_NONMOVIES.indexOf(this.props.applicationState.currentFocus) > -1
      ) {
        this.props.setFocus(EPISODEFOCUS);
        this.setState({
          slidePage: -resolution.detail.positionListEpisodesDown
        });

        if (SendAnalyticsCallEpisodeOnce === true) {
          trackPage.call(this, PAGE_EPISODE);
          SendAnalyticsCallEpisodeOnce = false;
        }
      }
    } else if (pressedKey === "ARROW_UP") {
      if (
        this.state.hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        this.props.applicationState.currentFocus === SEASONFOCUS
      ) {
        this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);
        this.setState({
          slidePage: resolution.detail.positionListEpisodesUp
        });
      }
    }
  };

  async componentDidMount() {
    const getPlatform = await getSdk().systemManager.device.getPlatform();
    this.setState({
      isOnLG: getPlatform === "webos" ? true : false
    });
    const { history, location } = this.props;
    this.mounted = true;
    document.addEventListener("keydown", this.keydownHandler);
    sdk = await getSdk();
    if (!isComingFromDetailPageScope.call(this)) {
      // This will happen when the deep linking is used and in this case the media list cache needs to be removed in
      // order to get the new title's media list data and not show the previous one's.
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
    }
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();

    location.state && !!location.state.deepLinkReferrer && (await startApp());
    trackPage.call(this, PAGE);
    this.setState({
      titleData: await this.fetchData(),
      isLoaded: true,
      isPlaying: false
    });
    this.props.onRef(this);
    fromWhere = this.props.location.referrer;
    // Send event
    !this.state.unAuthorizedAccess &&
      this.props.applicationState.userLogged &&
      this.props.location.referrer.search(/\/(episodes|player)$/) === -1 &&
      this.props.location.referrer !== this.props.location.pathname &&
      sendUserEvent({
        module_id: history.location.state ? history.location.state.moduleId : null,
        id: this.state.id,
        action: "detail_page"
      });

    await this.updateEpisodeData();
    await this.checkUpdatedEpisodes();
    this.props.setFocus(Detail.defaultFocusPath);
    sdk.playerManager.stop();
    // Force logout listening
    showForceLogoutError.call(this);
    await this.reloadWait(1000);
    if (this.props.applicationState.currentFocus === "episodesCarousel") {
      this.setState({
        slidePage: -resolution.detail.positionListEpisodesDown
      });
    }
  }

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  closeModal(focusPath = Detail.defaultFocusPath) {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(focusPath);
  }

  async updateEpisodeData() {
    const { history, location } = this.props;
    history.replace({
      ...location,
      state: {
        ...(await getEpisodeSelectorData.call(this)),
        from: location?.state?.from
      }
    });
    this.setState({ hasAllDataLoaded: true });
  }

  async playHandler(isRestarting) {
    const currentAddOn = getAddOnByName(this.state.addonContent);
    const {
      match: {
        params: { titleId }
      },
      applicationState: { userLogged, userAccountStatus, addons, currentFocus },
      setFocus,
      stateActions
    } = this.props;
    let eventAction = (isRestarting === true && "play_from_beginning") || "play";
    trackEvent(PAGE, eventAction, titleId);
    const boundCloseModal = this.closeModal.bind(this, currentFocus);
    // check if the content is free to play(f2p)
    let isContentFreeToPlay = false
    // checking if content is an episode, then check the episode tags instead of title tags
    let contentEpisodeData = this.episodesList && this.episodesList.filter(x=>x?.id===this?.lastEpisode?.id)
    if(contentEpisodeData && contentEpisodeData.length>0){
      isContentFreeToPlay = isFVODFreeToAir(contentEpisodeData[0]?.tags)
    } else if(this.state.titleData && this.state.titleData.tags){
      isContentFreeToPlay = isFVODFreeToAir(this.state.titleData.tags)
    }
    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(this.state.addonContent) && !isContentFreeToPlay) {
        return showInvalidStatusModal.call(this, boundCloseModal);
      }

      if (isCricketAddOn(this.state.addonContent) && isCricketAcquiresFrom(this.state.addonContent)) {
        if (
          !isUserSubscribedToChannel(addons, this.state.addonContent) &&
          isT20ChildSubscribed(this.state.addonContent)
        ) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, boundCloseModal, currentAddOn.displayName);
        } else if (
          !isUserSubscribedToChannel(addons, this.state.addonContent) &&
          !isT20ChildSubscribed(this.state.addonContent)
        ) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(
            this,
            boundCloseModal,
            `${currentAddOn.displayName} & ${CricChildAddOn(this.state.addonContent)?.displayName}`
          );
        }
      } else if (isT20AddOn(this.state.addonContent)) {
        if (
          !isUserSubscribedToChannel(addons, this.state.addonContent) &&
          isT20ParentSubscribed(this.state.addonContent)
        ) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, boundCloseModal, currentAddOn.displayName);
        } else if (
          !isUserSubscribedToChannel(addons, this.state.addonContent) &&
          !isT20ParentSubscribed(this.state.addonContent)
        ) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(
            this,
            boundCloseModal,
            `${T20ParentAddOn(this.state.addonContent)?.displayName} & ${currentAddOn.displayName}`
          );
        }
      } else {
        if (
          isMainPackageAddOn(this.state.addonContent) &&
          isSpSportsAddonContent(this.state.addonContent) &&
          !isUserSubscribedToSpSportsChannel(addons, this.state.addonContent)
        ) {
          return showSportPackageSubscriptionErrorPopup.call(this, boundCloseModal, getSpSportsPackageDisplayName());
        }
        if (
          !isMainPackageAddOn(this.state.addonContent) &&
          !isStandAloneAddon(this.state.addonContent) &&
          isSpSportsAddonContent(this.state.addonContent) &&
          !isUserSubscribedToSpSportsChannel(addons, this.state.addonContent)
        ) {
          return showSportPackageSubscriptionErrorPopup.call(this, boundCloseModal, getSpSportsPackageDisplayName());
        }
        if (!isUserSubscribedToChannel(addons, this.state.addonContent)) {
          return showChannelSubscriptionErrorPopupNew.call(this, boundCloseModal);
        }
      }

      if (!this.isThisDeviceSupported) {
        return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
      }

      this.isRestarting = isRestarting;
      if (!!getAppState().isOnline) {
        await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
      } else {
        stateActions.showGlobalModal(
          getConfigForModalWithCloseButton(
            {
              title: i18n.get("global.errors.internetConnectivity.title"),
              text: i18n.get("global.errors.internetConnectivity.text")
            },
            boundCloseModal
          )
        );
        setFocus(getGlobalButtonFocusPath("close"));
      }
      // Add GA Event on play button if there is no error
      trackEvent("play", "video_play_click", titleId);
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  async handleEnter(episodeTitle) {
    const currentAddOn = getAddOnByName(episodeTitle.addonContent);
    const {
      applicationState: { userLogged, userAccountStatus, addons, currentFocus }
    } = this.props;
    const boundClosemodal = this.closeModal.bind(this, currentFocus);
    // check if the content is free to play(f2p), for series
    let isContentFreeToPlay = false
    if(episodeTitle && episodeTitle.tags){
      isContentFreeToPlay = isFVODFreeToAir(episodeTitle?.tags)
    }
    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(episodeTitle.addonContent) && !isContentFreeToPlay) {
        return showInvalidStatusModal.call(this, boundClosemodal);
      }
      if (isCricketAddOn(episodeTitle.addonContent) && isCricketAcquiresFrom(episodeTitle.addonContent)) {
        if (
          !isUserSubscribedToChannel(addons, episodeTitle.addonContent) &&
          isT20ChildSubscribed(episodeTitle.addonContent)
        ) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, boundClosemodal, currentAddOn.displayName);
        } else if (
          !isUserSubscribedToChannel(addons, episodeTitle.addonContent) &&
          !isT20ChildSubscribed(episodeTitle.addonContent)
        ) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(
            this,
            boundClosemodal,
            `${currentAddOn.displayName} & ${CricChildAddOn(episodeTitle.addonContent)?.displayName}`
          );
        }
      } else if (isT20AddOn(episodeTitle.addonContent)) {
        if (
          !isUserSubscribedToChannel(addons, episodeTitle.addonContent) &&
          isT20ParentSubscribed(episodeTitle.addonContent)
        ) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, boundClosemodal, currentAddOn.displayName);
        } else if (
          !isUserSubscribedToChannel(addons, episodeTitle.addonContent) &&
          !isT20ParentSubscribed(episodeTitle.addonContent)
        ) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(
            this,
            boundClosemodal,
            `${T20ParentAddOn(episodeTitle.addonContent)?.displayName} & ${currentAddOn.displayName}`
          );
        }
      } else {
        if (
          isMainPackageAddOn(episodeTitle.addonContent) &&
          isSpSportsAddonContent(episodeTitle.addonContent) &&
          !isUserSubscribedToSpSportsChannel(addons, episodeTitle.addonContent)
        ) {
          return showSportPackageSubscriptionErrorPopup.call(this, boundClosemodal, getSpSportsPackageDisplayName());
        }
        if (
          !isMainPackageAddOn(episodeTitle.addonContent) &&
          !isStandAloneAddon(episodeTitle.addonContent) &&
          isSpSportsAddonContent(episodeTitle.addonContent) &&
          !isUserSubscribedToSpSportsChannel(addons, episodeTitle.addonContent)
        ) {
          return showSportPackageSubscriptionErrorPopup.call(this, boundClosemodal, getSpSportsPackageDisplayName());
        }
        if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent)) {
          return showChannelSubscriptionErrorPopup.call(this, boundClosemodal);
        }
      }

      if (!this.isThisDeviceSupported) {
        return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
      }
      this.episodeTitle = episodeTitle;
      showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  async checkUpdatedEpisodes() {
    const {
      history: {
        location: { state }
      }
    } = this.props;
    if (fromWhere === routes.player) {
      try {
        const updatedEpisodes = await getSeasonsAndEpisodesList(state.seriesId, true);
        Object.assign(state, {
          episodesList: state.episodesList.map((episode, index) =>
            Object.assign(episode, updatedEpisodes.episodesList[index])
          ),
          lastEpisode: updatedEpisodes.lastEpisode
        });
        this.setState({ isLoaded: true });
      } catch (e) {
        this.setState({ isLoaded: true });
      }
    }

    this.setState({ isLoaded: true });
  }

  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    this.setState({
      isPlaying: true
    });
    const { from, ...state } = history.location.state;
    return redirectTo.call(this, routes.player, {
      ...state,
      ...videoData
    });
  }

  async play(is4K, isSelectedFromResolutionPopup) {
    if (this.props.applicationState.currentFocus !== "episodesCarousel") {
      const {
        setFocus,
        match: {
          params: { titleId }
        }
      } = this.props;
      const episodesLoaded = !this.isSeries || (await this.episodesLoad);
      const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, is4K));
      // adding isFreeToAir to the videoData, this will be available in locationState.isFreeToAir in player page
      Object.assign(videoData, { playFrom: PLAY_FROM_LABEL, isFreeToAir: this.isSeries && this.episodeTitle?.isFreeContent || this.state?.titleData?.isFreeContent });
      isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      setFocus(Detail.defaultFocusPath);
      this.goPlayer(videoData);
    } else {
      const {
        location: {
          state: { seriesId }
        },
        setFocus,
        stateActions: { hideGlobalModal }
      } = this.props;
      !!getAppState().globalModal && hideGlobalModal();
      const videoData = await this.getVideoData(is4K);
      if (this.mounted) {
        isSelectedFromResolutionPopup && trackEvent("detail", is4K ? "4K" : "HD", seriesId);
        trackEvent(
          "detail",
          "play_from_episode_selector",
          `${seriesId}-S${this.episodeTitle.tvSeasonNumber}E${this.episodeTitle.tvSeasonEpisodeNumber}`
        );
        sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
        setFocus(EpisodesSelector.defaultFocusPath);
        redirectTo.call(this, routes.player, videoData);
      }
    }
  }

  // FIXME There is a really similar function in DetailPage.js, we should have the logic in one place only
  async getVideoData(is4K) {
    const { location } = this.props;
    const media = is4K
      ? await this.get4KMediaContent(this.episodeTitle["4kProgramId"])
      : this.episodeTitle.mediaContent[0];
    return {
      videoType: "series",
      manifest: media.content.video.streamingUrl,
      releasePid: media.content.video.releasePid,
      releaseUrl: media.content.video.releaseUrl,
      duration: media.content.video.duration,
      filmstrip: media.content.filmstrip,
      description: this.episodeTitle.shortDescription || this.episodeTitle.description,
      title: this.episodeTitle.title,
      tvSeasonNumber: this.episodeTitle.tvSeasonNumber,
      tvSeasonEpisodeNumber: this.episodeTitle.tvSeasonEpisodeNumber,
      playbackTime: this.episodeTitle.progress && this.episodeTitle.progress.playbackTime,
      seriesTitle: location.state.seriesTitle,
      episodeLabel: getEpisodeLabel(this.episodeTitle.tvSeasonNumber, this.episodeTitle.tvSeasonEpisodeNumber),
      seasonsList: this.seasonsList,
      episodesList: this.episodesList || location.state.episodesList,
      id: this.episodeTitle.id,
      seriesId: location.state.seriesId,
      moduleId: location.state.moduleId,
      has4K: location.state.has4K,
      //externalSubtitles: is4K && media.content.subtitles
      externalSubtitles: media.content.subtitles,
      mediaGuid: media.mediaGuid,
      credits: media.credits,
      playFrom: PLAY_FROM_LABEL,
      isFreeToAir: this.episodeTitle.isFreeContent // this is available in locationState.isFreeToAir in player page
    };
  }

  async get4KMediaContent(id) {
    let title;
    try {
      const { location } = this.props;
      if (this.episodesList && this.episodesList.length) {
        title = this.episodesList.find(episode => !!episode["4kProgramId"] && episode["4kProgramId"] === id);
      } else {
        title = await sdk.mediaManager.getTitle(id, { is4K: true });
      }
      return title.title4K ? title.title4K.mediaContent[0] : title.mediaContent[0];
    } catch (e) {
      if (this.mounted) {
        showAndReportUserRelatedError.call(this, {
          modalText: i18n.get("global.errors.genericError"),
          buttons: [
            {
              ...getGlobalButtonInfo("close"),
              buttonHandler: this.closeModal
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    }
  }

  onBack() {
    const {
      match: {
        params: { titleId }
      },
      stateActions,
      applicationState,
      location,
      history
    } = this.props;
    const dismissable = applicationState.globalModal && applicationState.globalModal.dismissable;
    trackEvent(PAGE, "back", titleId);
    if (!!applicationState.globalModal) {
      this.closeModal();
      if (!dismissable) {
        return true;
      }
    }
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;
    applicationState.userMediaCached = null;

    if (isDeepLinkReferrer) {
      history.push(stateActions.getHomePath(isDeepLinkReferrer, !!this.isSeries), {
        deepLinkReferrer: false
      });
      return true;
    }
    this.isExiting = true;
    const to = location.state?.from?.name === "/" ? "/home" : location.state?.from?.name;
    if (to === "/search") {
      history.goBack();
      return true;
    }
    if (to) {
      history.replace(to, {
        ...(location.state || {})
      });
      return true;
    }
    history.goBack();
    return true;
  }

  getIconButtonPlay() {
    const {
      applicationState: { addons }
    } = this.props;
    const { addonContent } = this.state;
    return !isUserSubscribedToChannel(addons, addonContent) ? "premiumContentEmpty" : "play";
  }

  async fetchData() {
    sdk = await getSdk();
    try {
      const {
        applicationState: { userLogged },
        match: {
          params: { titleId }
        }
      } = this.props;
      const requests = [
        sdk.mediaManager.getTitle(titleId, {
          is4K: true,
          offline: !getAppState().isOnline
        }), // [0] Title
        userLogged ? await getUserMediaLists(titleId, checkMediaListsData.bind(this)) : true, // [1] User Media
        this.isSeries ? getSeasonsList.call(this, titleId) : [] // [2] Seasons Series
      ];
      const results = requests.map(async req => await req);
      const title = await results[0];
      this.isThisDeviceSupported = userLogged
        ? await isSupportedDeviceForMobileLite.call(this, title.addonContent)
        : true;

      if (this.isSeries) {
        // FIXME: This should be done in the middleware instead.
        title.mediaContent.sort(sorter(MEDIAGUID));

        // Map the 4K episodes.
        this.title4K = {};
        !!title.title4K &&
          !!title.title4K.mediaContent &&
          title.title4K.mediaContent.forEach(
            media => (this.title4K[getSeasonEpisodeFromMediaGuid(media.mediaGuid)] = media)
          );
      }
      userLogged && (await results[1]);
      const seasons = await results[2];
      const videoType = getSupportedVideoTechnology();

      const firstEpisode =
        this.isSeries && findFirstEpisodeBySeason(title.mediaContent, this.seasonsListRaw[0].tvSeasonNumber);
      const firstEpisodeFromMediaGuid = firstEpisode && getSeasonEpisodeFromMediaGuid(firstEpisode.mediaGuid);
      const firstEpisodeNumber = firstEpisodeFromMediaGuid && parseInt(firstEpisodeFromMediaGuid.split("E")[1]);
      const firstEpisodeAvailable =
        this.isSeries && !this.resumeEpisode
          ? getEpisodeLabel(this.seasonsListRaw[0].tvSeasonNumber, !isNaN(firstEpisodeNumber) && firstEpisodeNumber)
          : undefined;

      const mediaHD = getMediaContentData.call(this, title, false);
      const media4K = !!title.title4K && getMediaContentData.call(this, title.title4K, true);
      this.mediaData = {
        mediaHD,
        media4K,
        videoHD: mediaHD.content.video[videoType] || mediaHD.content.video,
        video4K: !!media4K && (media4K.content.video[videoType] || media4K.content.video)
      };

      this.setState({
        backgroundCover: title.images.hero,
        firstEpisodeAvailable,
        trailer: getTrailer(title),
        title: title.title,
        description: title.shortDescription,
        id: title.id,
        has4K: !!title[HAS_4K],
        addonContent: title.addonContent,
        isLive: title.isLive
      });
      return formatDetailData.call(this, title, seasons);
    } catch (e) {
      !this.isExiting && showRetryOrBackModal.call(this, e);
    }
  }

  scrollUpDown(event) {
    this.wheelState = "active";
    if (event.deltaY > 0) {
      // down wheel moves
      if (this.state.hasEpisodes && this.seasonsList && this.episodesList) {
        if (BUTTONS_LIST_NONMOVIES.indexOf(this.props.applicationState.currentFocus) > -1) {
          this.props.setFocus(EPISODEFOCUS);
          this.setState({
            slidePage: -resolution.detail.positionListEpisodesDown
          });
          if (SendAnalyticsCallEpisodeOnce === true) {
            trackPage.call(this, PAGE_EPISODE);
            SendAnalyticsCallEpisodeOnce = false;
          }
        } else if (this.props.applicationState.currentFocus === SEASONFOCUS) {
          this.props.setFocus(EPISODEFOCUS);
        }
      }
    } else if (event.deltaY < 0) {
      // up wheel moves
      if (this.state.hasEpisodes && this.seasonsList && this.episodesList) {
        if (this.props.applicationState.currentFocus === SEASONFOCUS) {
          this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);
          this.setState({
            slidePage: resolution.detail.positionListEpisodesUp
          });
        } else if (this.props.applicationState.currentFocus === EPISODEFOCUS) {
          this.props.setFocus(SEASONFOCUS);
        }
      }
    }
  }

  render() {
    this.lastEpisode = this.props?.location?.state?.lastEpisode;

    return (
      <DetailWrapperStyled url={this.state.backgroundCover}>
        {this.state.isLoaded ? (
          <DetailContainerStyled
            onWheel={e => {
              this.scrollUpDown(e);
            }}
            position={this.state.slidePage}
          >
            <DetailPageStyled isSeries={this.isSeries}>
              <Detail
                data={this.state.titleData}
                playHandler={this.playHandler}
                trailerHandler={trackAndRedirectHandler.bind(
                  this,
                  PAGE,
                  "trailer",
                  routes.player,
                  getTrailerVideoData.call(this)
                )}
                addHandler={myListHandler.bind(this)}
                isSavedInMyWatchlist={this.state.isSavedInMyWatchlist}
                separator={config.get().locales[i18n.getLocale()].separator}
                direction={i18n.getDirection()}
                firstEpisodeAvailable={this.state.firstEpisodeAvailable}
                currentFocus={this.props.applicationState.currentFocus}
                isPageSlides={this.state.slidePage < 0 ? true : false}
                isUserLoggedIn={this.props.applicationState.userLogged}
              />
            </DetailPageStyled>
            <section
              onClick={() => {
                this.setState({
                  slidePage: -resolution.detail.positionListEpisodesDown
                });
              }}
            >
              {this.isSeries &&
                (this.state.hasEpisodes && this.seasonsList && this.episodesList && this.state.hasAllDataLoaded ? (
                  <EpisodesSelector
                    seasonSelected={this.lastEpisode && this.lastEpisode.tvSeasonNumber}
                    episodeSelected={this.lastEpisode && this.lastEpisode.tvSeasonEpisodeNumber}
                    seasonsList={this.seasonsList}
                    episodesList={this.episodesList}
                    onEnterPress={this.handleEnter}
                    direction={i18n.getDirection()}
                    currentFocus={this.props.applicationState.currentFocus}
                    slideMarginStart={0}
                    MagicRemoteStatus={this.wheelState === "active" ? true : false}
                    showArrows={this.wheelState === "active" ? true : false}
                    fromDetailPage={true}
                    isOnLG={this.state.isOnLG}
                    hideSELabels={this.state.titleData.hideSELabels || false}
                  />
                ) : (
                  <ArrowScrollStyled
                    label={<Loading width="25px" height="25px" text={i18n.get("pages.detail.loadingEpisodes")} />}
                  />
                ))}
            </section>
          </DetailContainerStyled>
        ) : (
          <Loading overlay />
        )}
      </DetailWrapperStyled>
    );
  }
}

const Component = withAppState(withSubtheme(DetailPage));

Component.defaultFocusPath = Detail.defaultFocusPath;

export default Component;
